// form
import { CSSProperties } from 'react';
import { FormProvider as Form, UseFormReturn } from 'react-hook-form';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
  methods: UseFormReturn<any>;
  onSubmit?: VoidFunction;
  style?: CSSProperties | undefined;
};

export default function FormProvider({
  children,
  onSubmit,
  methods,
  style,
}: Props) {
  return (
    <Form {...methods}>
      <form noValidate onSubmit={onSubmit} style={style}>
        {children}
      </form>
    </Form>
  );
}
